import React, { useMemo } from "react";
import { Field } from "@progress/kendo-react-form";
import { FormRegion } from "../../../../components/formregion";
import { 
  setFormValue,
  setStepPages,
  setSteps,
  stepApiPages,
  stepDbPages,
  stepFilePages,
} from "../../../../redux/slices/importdatasetpageslice";
import {
  FormDropDownListById,
  FormRadioGroup,
} from "../../../../forms/form-components";
import { useDispatch, useSelector } from "react-redux";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

const SelectOptionForImport = () => {
  const dispatch = useDispatch();
  const pageState = useSelector((state) => state.importDatasetPage);
  const { t } = useTranslation();

  const fromDbSteps = [
    { label: t("datasets.importdataset.from"), isValid: true },
    { label: t("datasets.importdataset.fromdb"), isValid: undefined },
    { label: t("datasets.importdataset.tablequery"), isValid: undefined },
    { label: t("datasets.importdataset.review"), isValid: undefined },
    { label: t("datasets.importdataset.result"), isValid: undefined },
  ];
  const fromFileSteps = [
    { label: t("datasets.importdataset.from"), isValid: true },
    { label: t("datasets.importdataset.fromfile"), isValid: undefined },
    { label: t("datasets.importdataset.review"), isValid: undefined },
    { label: t("datasets.importdataset.result"), isValid: undefined },
  ];
  const fromApiSteps = [
    { label: t("datasets.importdataset.from"), isValid: true },
    { label: t("datasets.importdataset.fromapi"), isValid: true },
    { label: t("datasets.importdataset.review"), isValid: undefined },
    { label: t("datasets.importdataset.result"), isValid: undefined },
  ];

    const importDatasetFromList = [
  { label: t("datasets.importdataset.fromdbtable") , value: "fromdb" },
  { label: t("datasets.importdataset.fromfiletype"), value: "fromfile" },
  { label: t("datasets.importdataset.fromapiendpt"), value: "fromapi" },
];


  const handleOptionChange = (e) => {
    const value = e.value;
    dispatch(setFormValue({ id: "ImportFrom", value }));

    switch (value) {
      case "fromfile":
        dispatch(setSteps(fromFileSteps));
        dispatch(setStepPages(stepFilePages));
        break;
      case "fromdb":
        dispatch(setSteps(fromDbSteps));
        dispatch(setStepPages(stepDbPages));
        break;
      case "fromapi":
        dispatch(setSteps(fromApiSteps));
        dispatch(setStepPages(stepApiPages));
        break;
      default:
        break;
    }
  };

  return (
    <FormRegion>
      <div className="form-group form-group-1 stepper-rd-btns">
        <Field
          id={"ImportFrom"}
          name={"ImportFrom"}
          label={t("datasets.importdataset.import")}
          component={FormRadioGroup}
          data={importDatasetFromList}
          value={pageState.formValues.ImportFrom}
          onChange={handleOptionChange}
        />

        <Field
          id="SelectedDataset"
          name="SelectedDataset"
          label={t("datasets.importdataset.select")}
          component={FormDropDownListById}
          dataItemKey="Id"
          textField="Title"
          data={pageState.lst_of_datasets}
          onChange={(e) =>
            dispatch(setFormValue({ id: "SelectedDataset", value: e.value }))
          }
        />
      </div>
      <style>
        {`
          .datasets-page .stepper-rd-btns #ImportFrom_label {
            font-size: 16px;
            font-weight: semi-bold;
            margin-bottom: 20px;
          }
          .datasets-page .stepper-rd-btns .k-radio-list li {
            font-size: 16px;
            margin-bottom: 20px;
          }
        `}
      </style>
    </FormRegion>
  );
};

export default SelectOptionForImport;
